import { createBrowserRouter, Navigate } from 'react-router-dom';
import Layout from '@/views/layout';
import LayoutPage from '@/views/layout-page';
import Map from '@/views/map';
import Documentation from '@/views/documentation';
import Contact from '@/views/contact';
import Acknowledgments from '@/views/acknowledgments';
import Citation from '@/views/citation';
import DataDownload from '@/views/data-download';
import CPSSL from '@/views/cpssl';

export const router = createBrowserRouter([
  {
    path: '/',
    children: [
      {
        index: true,
        element: <Navigate to='/map' replace />,
      },
      {
        path: 'map',
        element: <Layout />,
        children: [
          {
            index: true,
            element: <Map />,
          },
        ],
      },
      {
        path: 'documentation',
        element: <LayoutPage />,
        children: [
          {
            index: true,
            element: <Documentation />,
          },
        ],
      },
      {
        path: 'data-download',
        element: <LayoutPage />,
        children: [
          {
            index: true,
            element: <DataDownload />,
          },
        ],
      },
      {
        path: 'cpssl',
        element: <LayoutPage />,
        children: [
          {
            index: true,
            element: <CPSSL />,
          },
        ],
      },
      {
        path: 'contact',
        element: <LayoutPage />,
        children: [
          {
            index: true,
            element: <Contact />,
          },
        ],
      },
      {
        path: 'acknowledgments',
        element: <LayoutPage />,
        children: [
          {
            index: true,
            element: <Acknowledgments />,
          },
        ],
      },
      {
        path: 'citation',
        element: <LayoutPage />,
        children: [
          {
            index: true,
            element: <Citation />,
          },
        ],
      },
    ],
  },
]);
